import PropTypes from 'prop-types';
import { Link } from 'react-router';
import React, { PureComponent } from 'react';
import { push } from 'react-router-redux';
import { bindActionCreators } from 'redux';
import { connect, ConfirmDialog, testClass } from 'omni-common-ui';
import CourseViewTable from 'components/CourseViewTable';
import styles from './style.postcss';
import { actions as GroupMembers } from 'data/GroupMembers';
import { actions as OnlineUsageActions } from 'data/OnlineUsage';
import { actions as Session } from 'data/SessionPlans';
import { getUnitList } from 'data/Units/accessors';

const HEADER_COMPLETION = 'Completion';
const HEADER_CATCH_UPS_TAKE = 'CatchUpsTake';
const HEADER_UNIT_AVERAGE = 'Average';
const HEADER_SPIN_PROGRESS = 'SpinProgress';
const DEFAULT_CELL = 'N/A';

class OnlineUsage extends PureComponent {
  constructor(props) {
    super(props);
    this._renderCell = this._renderCell.bind(this);
    this._closeSpinProgressPopUp = this._closeSpinProgressPopUp.bind(this);
  }

  componentWillMount() {
    this.props.fetchOnlineUsageIfNeeded(this.props.groupId);
  }

  _getHighlightedColumns() {
    const { units, defaultUnitId } = this.props;
    const defaultUnitIndex = units.toList().findIndex((unit) => unit.id === defaultUnitId) * 3;
    if (defaultUnitIndex < 0) {
      return undefined;
    }
    return [defaultUnitIndex, defaultUnitIndex + 1, defaultUnitIndex + 2];
  }

  _closeSpinProgressPopUp() {
    this.props.pushRoute(this.props.buildRoute({ mode: '', studentId: '' }));
  }

  _renderSpinProgressPopUp() {
    const { studentId, onlineUsages, selectedStudent } = this.props;
    if (! studentId) {
      return;
    }
    const studentOnlineUsages = onlineUsages.get(studentId);
    const selectedCourse = studentOnlineUsages.selectedCourse;
    const lableStyle = styles.OnlineUsage_popup_name_label;
    const ulStyle = styles.OnlineUsage_popup_ul;
    const nameStyle = styles.OnlineUsage_popup_name;
    return <ConfirmDialog isOpen
        title="Selected SPIN Courses"
        primaryButtonContent="Ok"
        onPrimaryClick={this._closeSpinProgressPopUp}>
      <div className={styles.OnlineUsage_popup}>
        <div className={nameStyle}>
          <span>English First Name:</span>
          <label className={lableStyle}>{selectedStudent.studentGeneralInfo.firstName}</label>
        </div>
        <div className={nameStyle}>
          <span>English Last Name:</span>
          <label className={lableStyle}>{selectedStudent.studentGeneralInfo.lastName}</label>
        </div>
        <hr />
        <ul className={ulStyle}>
          {selectedCourse.map((spin) => <li >{spin}</li>)}
        </ul>
      </div>
    </ConfirmDialog>;
  }

  _renderTableHeader() {
    const { units } = this.props;
    return <CourseViewTable.Header>
      <CourseViewTable.Row>
        {units.map((unit) =>
          <CourseViewTable.Cell key={unit.orderingSequence} colSpan={3} small>
            {unit.name}
          </CourseViewTable.Cell>)
        }
        <CourseViewTable.Cell key={units.size + 1} colSpan={3} small>
          SPIN Progress
        </CourseViewTable.Cell>
      </CourseViewTable.Row>
      <CourseViewTable.Row>
        {
          units.map((unit) => [
            <CourseViewTable.Cell columnId={{ unit, column: HEADER_COMPLETION }} small>
              Activities Completion
            </CourseViewTable.Cell>,
            <CourseViewTable.Cell columnId={{ unit, column: HEADER_CATCH_UPS_TAKE }} small>
              Catch‑ups Take
            </CourseViewTable.Cell>,
            <CourseViewTable.Cell columnId={{ unit, column: HEADER_UNIT_AVERAGE }} small>
              Unit Average
            </CourseViewTable.Cell>,
          ])
        }
        <CourseViewTable.Cell columnId={{ column: HEADER_SPIN_PROGRESS }} colSpan={3} small>
          Completion
        </CourseViewTable.Cell>
      </CourseViewTable.Row>
    </CourseViewTable.Header>;
  }

  _getStudentSpinProgress(studentId) {
    return this.props.buildRoute({ mode: 'spin-grogress', studentId });
  }

  _renderCell(member, { unit, column }) {
    const { onlineUsages } = this.props;
    const studentOnlineUsages = onlineUsages.get(member.studentGeneralInfo.id);
    if (! studentOnlineUsages || ! studentOnlineUsages.unitOnlineUsages) {
      return 'N/A';
    }
    let unitOnlineUsage;
    if (unit) {
      unitOnlineUsage = studentOnlineUsages.unitOnlineUsages.get(`${unit.orderingSequence}`);
    }
    if (! unitOnlineUsage && column !== HEADER_SPIN_PROGRESS) return 'N/A';

    switch (column) {
      case HEADER_COMPLETION:
        return unitOnlineUsage.activitiesComplete || DEFAULT_CELL;
      case HEADER_CATCH_UPS_TAKE:
        return unitOnlineUsage.catchUpsTaken || DEFAULT_CELL;
      case HEADER_UNIT_AVERAGE:
        return unitOnlineUsage.unitAverage || DEFAULT_CELL;
      case HEADER_SPIN_PROGRESS: {
        return studentOnlineUsages.spinProcess ?
          <Link to={this._getStudentSpinProgress(member.studentGeneralInfo.id)}
              className={styles.OnlineUsage_spinLink}>{studentOnlineUsages.spinProcess}</Link> :
          DEFAULT_CELL;
      }
      default:
        break;
    }
  }

  render() {
    const { members, onlineUsages } = this.props;
    if (onlineUsages && members) {
      return <div className={testClass('test-courseviewTable')}>
        <CourseViewTable students={members} highlightedColumns={this._getHighlightedColumns()} >
          {this._renderTableHeader()}
          <CourseViewTable.Body>
            {this._renderCell}
          </CourseViewTable.Body>
        </CourseViewTable>
        {this._renderSpinProgressPopUp()}
      </div>;
    }
    return <div />;
  }

}

OnlineUsage.propTypes = {
  groupId: PropTypes.string.isRequired,
  members: PropTypes.array.isRequired,
  fetchOnlineUsageIfNeeded: PropTypes.func.isRequired,
  pushRoute: PropTypes.func.isRequired,
  defaultUnitId: PropTypes.string,
  studentId: PropTypes.string,
  onlineUsages: PropTypes.object,
  selectedStudent: PropTypes.object,
  units: PropTypes.object,
  buildRoute: PropTypes.func,
};

export function mapStateToProps(state, ownProps) {
  const { groupId, studentId } = ownProps.params;
  const members = GroupMembers.getMembersByGroup(state, groupId);
  const onlineUsages = state.get('rootReducer').get('onlineUsage').get(groupId);
  const selectedStudent = GroupMembers.getMemberById(state, studentId);
  const units = getUnitList(state, groupId);
  const defaultSession = Session.getDefaultSession(state, groupId);
  const defaultUnitId = `${defaultSession.unitIds[0]}`;
  return {
    groupId,
    studentId,
    selectedStudent,
    defaultUnitId,
    members,
    units,
    onlineUsages,
  };
}

function mapDispatchToProps(dispatch) {
  return Object.assign({},
    { pushRoute: (path) => dispatch(push(path)) },
    bindActionCreators(OnlineUsageActions, dispatch),
    bindActionCreators(GroupMembers, dispatch)
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(OnlineUsage);



// WEBPACK FOOTER //
// ./containers/Group/Homework/OnlineUsage/component.jsx